export const HANDLE_MANAGER_TICKET_AREA = "HANDLE_MANAGER_TICKET_AREA";
export const HANDLE_FILTER_AREA = "HANDLE_FILTER_AREA";

export const GET_MANAGER_TICKET_LIST = "GET_MANAGER_TICKET_LIST";
export const GET_MANAGER_TICKET_LIST_SUCCESS = "GET_MANAGER_TICKET_LIST_SUCCESS";
export const GET_MANAGER_TICKET_LIST_ERROR = "GET_MANAGER_TICKET_LIST_ERROR";

export const GET_MANAGER_TICKET_FORMS = "GET_MANAGER_TICKET_FORMS";
export const GET_MANAGER_TICKET_FORMS_SUCCESS = "GET_MANAGER_TICKET_FORMS_SUCCESS";
export const GET_MANAGER_TICKET_FORMS_ERROR = "GET_MANAGER_TICKET_FORMS_ERROR";

export const SET_MANAGER_TICKET_FILTER = "SET_MANAGER_TICKET_FILTER";
export const RESET_MANAGER_TICKET_FILTER = "RESET_MANAGER_TICKET_FILTER";

export const NEXT_MANAGER_TICKET_PAGE = "NEXT_MANAGER_TICKET_PAGE";
export const PREV_MANAGER_TICKET_PAGE = "PREV_MANAGER_TICKET_PAGE";
export const SET_MANAGER_TICKET_PAGE = "SET_MANAGER_TICKET_PAGE";

export const SET_MANAGER_TICKET_SORT = "SET_MANAGER_TICKET_SORT";
export const RESET_MANAGER_TICKET_SORT = "RESET_MANAGER_TICKET_SORT";
